import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { ComponentTypeDefaultIcons } from "../../program/icons";
import { ComponentType } from "../../../constants";
import WorkoutOverview from "../../program-calendar/WorkoutOverview";
import { CurriculumComponent } from "../../../redux/types";
import { SquarePen, Eye } from "lucide-react";
import { getColorByComponentType } from "../../program-calendar/utils/common";
import { useEnableColors } from "../../../hooks/useEnableColors";
import { useComponentTemplateDialog } from "../../../contexts/ComponentTemplateDialogContext";

interface IGenericComponentContainerProps {
  componentData: CurriculumComponent;
  coachId: number | undefined;
}

const TemplateComponentTitle = (title, iconName, componentData) => {
  const { openDialog } = useComponentTemplateDialog();
  const Icon = iconName;
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: " center",
        gap: 1,
        p: 1.5,
        marginBlock: 1,
        borderBottom: 2,

        ":hover": {
          cursor: "pointer",
        },
      }}
      onClick={() => openDialog(componentData as any)}
    >
      <Box
        sx={{
          "& svg": {
            width: 25,
            height: 25,
          },
        }}
      >
        <Icon />
      </Box>
      <Typography
        sx={{
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

const TemplateSidebarDetailsTab = (props: IGenericComponentContainerProps) => {
  const { componentData, coachId } = props;
  const { type } = componentData;
  const theme = useTheme();
  const color = getColorByComponentType(type);
  const enableColors = useEnableColors();
  const { openDialog } = useComponentTemplateDialog();

  const getMainComponent = () => {
    switch (type) {
      case ComponentType.WORKOUT:
        return <WorkoutOverview result={componentData} />;
      case ComponentType.LESSON:
      case ComponentType.HABIT:
      case ComponentType.CHECKIN:
        return <></>;

      default:
        break;
    }
  };

  return (
    <>
      <Box
        sx={{
          p: 2,
          pt: 0,
          pb: 0,
          overflow: "scroll",
          scrollbarGutter: "stable both-edges",
          display: "flex",
          flexDirection: "column",
          flex: 1,
          height: 1,
        }}
      >
        {TemplateComponentTitle(
          componentData.title,
          ComponentTypeDefaultIcons[type],
          componentData,
        )}
        {getMainComponent()}

        <Box
          sx={{
            marginTop: "auto",
            pb: 2,
            position: "sticky",
            bottom: 0,
            background: theme.palette.background.paper,
            ...(enableColors && { color }),
          }}
        >
          <Button
            fullWidth
            variant="contained"
            startIcon={coachId ? <SquarePen /> : <Eye />}
            sx={{ fontWeight: 600 }}
            onClick={() =>
              openDialog(componentData as any, coachId ? true : false)
            }
          >
            {coachId ? "Edit" : "View"}
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default TemplateSidebarDetailsTab;
